import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacarrentalmumbai() {



    const cardData = {

keyword: "Innova Car Rental Mumbai",

headingDescription:
    "Mumbai Airport Cab offers premium and affordable Innova Car Rental Mumbai services for airport transfers, local travel, corporate trips, family vacations, weddings, and outstation journeys. Our well-maintained Toyota Innova and Innova Crysta vehicles provide spacious seating, superior comfort, ample luggage space, and smooth travel for families and groups. With professional chauffeurs, 24x7 availability, transparent pricing, doorstep pickup and drop, and flexible booking options, we ensure a safe, comfortable, and hassle-free travel experience across Mumbai and beyond.",

topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is one of the twelve sacred Jyotirlingas and a highly preferred pilgrimage destination from Mumbai. An Innova is ideal for families and groups traveling comfortably through the scenic Sahyadri routes while enjoying a peaceful spiritual journey."
    },
    {
        title: "Ganpatipule",
        description:
            "Ganpatipule is a famous Konkan destination known for its pristine beach and revered Ganpati temple. Innova rentals are frequently booked for this long-distance coastal journey due to the vehicle’s comfort and spacious interiors."
    },
    {
        title: "Saputara",
        description:
            "Saputara, Gujarat’s only hill station, offers beautiful valleys, lakes, ropeway rides, and cool weather. The destination is perfect for family vacations, and an Innova provides a relaxed travel experience on the scenic highway route."
    },
    {
        title: "Tarkarli",
        description:
            "Tarkarli is renowned for crystal-clear beaches, scuba diving, and water sports. Families and groups often prefer Innova rentals for the long road trip, enjoying comfort, luggage space, and smooth highway performance."
    },
    {
        title: "Kolad",
        description:
            "Kolad is Maharashtra’s adventure capital, famous for river rafting, camping, and outdoor activities. An Innova rental is ideal for adventure groups traveling with equipment and luggage while ensuring a comfortable ride."
    },
    {
        title: "Harihareshwar",
        description:
            "Harihareshwar combines spiritual significance with coastal beauty, attracting both pilgrims and leisure travelers. Innova cars offer a convenient option for families visiting the temple and nearby beaches."
    },
    {
        title: "Bhandardara",
        description:
            "Bhandardara is a picturesque hill destination known for Arthur Lake, waterfalls, and mountain views. The spacious seating of an Innova makes it an excellent choice for nature lovers planning weekend trips from Mumbai."
    },
    {
        title: "Amboli",
        description:
            "Amboli is a beautiful hill station known for misty landscapes, dense forests, and spectacular waterfalls. Innova rentals are popular for this route because of the vehicle’s comfort during long-distance mountain travel."
    },
    {
        title: "Velas",
        description:
            "Velas is famous for its turtle festival and untouched beach environment. Travelers seeking a peaceful coastal getaway often choose Innova rentals for a comfortable and enjoyable road journey."
    },
    {
        title: "Ujjain",
        description:
            "Ujjain is one of India’s holiest cities and home to the Mahakaleshwar Jyotirlinga. Innova rentals are widely preferred for long-distance pilgrimage tours due to their reliability, comfort, and spacious seating capacity."
    }
],



services: [
{
name: "Innova Car Rental Mumbai",
description: "Mumbai Airport Cab offers Innova Car Rental Mumbai service for travellers seeking spacious, reliable, and comfortable transportation across Mumbai and outstation destinations. Our Toyota Innova and Innova Crysta vehicles are ideal for family vacations, corporate travel, airport transfers, wedding transportation, business meetings, sightseeing tours, and long-distance road trips. With professional chauffeurs, well-maintained AC vehicles, ample luggage space, flexible booking options, doorstep pickup, transparent pricing, and 24x7 customer support, we ensure every journey is safe, convenient, and enjoyable. Whether you need a cab for a few hours, a full day, or a multi-day outstation tour, our Innova rental service provides premium comfort and dependable travel solutions."
},
{
name: "Mumbai Innova Rental",
description: "Mumbai Airport Cab provides Mumbai Innova Rental service with premium chauffeur-driven vehicles designed for comfortable group travel, airport transfers, family outings, corporate transportation, and intercity journeys. Our clean and spacious Innova fleet offers generous seating capacity, luggage space, air-conditioned comfort, and smooth performance on both city roads and highways. We focus on punctual service, experienced drivers, transparent pricing, flexible schedules, and hassle-free booking to ensure every customer enjoys a reliable and stress-free travel experience throughout Mumbai and surrounding destinations."
},
{
name: "Innova Cab Mumbai",
description: "Book Innova Cab Mumbai with Mumbai Airport Cab and enjoy comfortable transportation for local travel, airport pickup and drop, business meetings, family functions, sightseeing tours, and outstation trips. Our professionally maintained Innova vehicles are driven by trained chauffeurs who prioritize safety, punctuality, and customer satisfaction. With spacious interiors, comfortable seating, clean cabins, and reliable service, we provide an excellent travel experience for individuals, families, and corporate groups across Mumbai and beyond."
},
{
name: "Mumbai Innova Cab Service",
description: "Mumbai Airport Cab offers Mumbai Innova Cab Service for customers looking for premium SUV transportation with superior comfort and convenience. Our Innova vehicles are suitable for airport transfers, family vacations, business travel, wedding transportation, city sightseeing, and long-distance journeys. We provide experienced drivers, well-maintained vehicles, flexible travel schedules, and dedicated customer support to ensure safe and enjoyable travel for every passenger throughout Mumbai and major destinations across Maharashtra and India."
},
{
name: "Hire Innova in Mumbai",
description: "Hire Innova in Mumbai through Mumbai Airport Cab and experience spacious, comfortable, and dependable travel for any occasion. Our Innova vehicles are perfect for family trips, corporate travel, airport transfers, holiday tours, religious pilgrimages, and special events. We offer professional chauffeurs, clean AC vehicles, flexible rental packages, competitive pricing, and round-the-clock booking support, ensuring a smooth and convenient travel experience for local and outstation journeys."
},
{
name: "Innova on Rent Mumbai",
description: "Mumbai Airport Cab provides Innova on Rent Mumbai service with premium SUV vehicles suitable for local travel, airport transportation, business meetings, family vacations, and long-distance road trips. Our fleet is regularly maintained for safety and comfort, while our professional chauffeurs ensure timely service and smooth travel. Customers benefit from transparent pricing, flexible travel plans, doorstep pickup, and personalized transportation solutions designed to meet every travel requirement."
},
{
name: "Mumbai Innova Car Hire",
description: "Choose Mumbai Innova Car Hire from Mumbai Airport Cab for reliable and comfortable transportation across Mumbai and outstation destinations. Our spacious Innova vehicles are ideal for families, corporate teams, tourists, and groups requiring extra seating and luggage capacity. We provide professional drivers, well-maintained vehicles, convenient booking options, and exceptional customer support to ensure safe, enjoyable, and hassle-free travel for every journey."
},
{
name: "Innova Outstation Cab Mumbai",
description: "Mumbai Airport Cab offers Innova Outstation Cab Mumbai service for comfortable long-distance travel to destinations such as Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Lonavala, Aurangabad, and more. Our spacious SUVs provide superior comfort, luggage capacity, and smooth highway performance. With experienced chauffeurs, flexible itineraries, transparent pricing, and 24x7 support, we deliver safe and dependable transportation for family vacations, business trips, and holiday tours."
},
{
name: "Mumbai Innova Taxi Service",
description: "Mumbai Innova Taxi Service by Mumbai Airport Cab provides premium transportation solutions for airport transfers, local travel, corporate rides, sightseeing tours, and outstation journeys. Our Innova vehicles offer spacious seating, air-conditioned comfort, and professional chauffeur service to ensure a pleasant travel experience. We focus on reliability, punctuality, safety, and customer satisfaction while delivering high-quality transportation services throughout Mumbai."
},
{
name: "Mumbai Innova Booking Service",
description: "Mumbai Airport Cab provides Mumbai Innova Booking Service with simple reservation options, instant confirmation, flexible scheduling, and dedicated customer support. Whether you require transportation for airport transfers, business meetings, family events, sightseeing tours, or outstation travel, our professionally maintained Innova vehicles and experienced chauffeurs ensure a safe, comfortable, and efficient travel experience from start to finish."
},
{
name: "Innova Crysta Rental Mumbai",
description: "Innova Crysta Rental Mumbai offers premium SUV transportation with enhanced comfort, luxury interiors, spacious seating, and superior ride quality. Mumbai Airport Cab provides chauffeur-driven Innova Crysta vehicles for airport transfers, executive travel, family vacations, wedding transportation, corporate events, and long-distance journeys. Our focus on vehicle quality, professional service, and customer satisfaction ensures a premium travel experience for every passenger."
},
{
name: "Mumbai Luxury Innova Cab",
description: "Mumbai Airport Cab offers Mumbai Luxury Innova Cab service for travellers seeking a premium transportation experience with exceptional comfort and convenience. Our luxury Innova vehicles feature spacious interiors, comfortable seating, air-conditioned cabins, and professional chauffeur service. Ideal for VIP travel, executive transportation, family tours, airport transfers, and special occasions, our service combines reliability, elegance, and superior customer care."
},
{
name: "Innova Airport Pickup Mumbai",
description: "Book Innova Airport Pickup Mumbai with Mumbai Airport Cab for seamless transportation from Mumbai International Airport and Domestic Airport terminals. Our chauffeurs monitor flight schedules, provide luggage assistance, and ensure timely pickups for arriving passengers. With spacious vehicles, comfortable seating, and professional service, we make airport transfers smooth, convenient, and stress-free for families, business travellers, and tourists."
},
{
name: "Innova Airport Drop Mumbai",
description: "Mumbai Airport Cab provides Innova Airport Drop Mumbai service with punctual pickup, professional chauffeurs, and comfortable transportation to Mumbai Airport terminals. Our spacious Innova vehicles accommodate passengers and luggage with ease while ensuring timely arrivals for domestic and international flights. We focus on reliability, safety, and customer convenience for a hassle-free airport transfer experience."
},
{
name: "Mumbai Family Innova Cab",
description: "Mumbai Family Innova Cab service is specially designed for families requiring spacious and comfortable transportation for vacations, sightseeing tours, airport transfers, weddings, and weekend getaways. Mumbai Airport Cab offers well-maintained Innova vehicles with professional chauffeurs, generous luggage space, comfortable seating, and safe travel arrangements. We ensure every family journey is enjoyable, convenient, and stress-free."
},
{
name: "Innova Wedding Car Mumbai",
description: "Mumbai Airport Cab offers Innova Wedding Car Mumbai service for wedding ceremonies, guest transportation, family functions, and special celebrations. Our elegant Innova vehicles provide spacious seating, premium comfort, and professional chauffeur service to ensure smooth transportation throughout your event. We focus on punctuality, vehicle cleanliness, and customer satisfaction to support memorable wedding experiences."
},
{
name: "Mumbai Innova Chauffeur Service",
description: "Mumbai Innova Chauffeur Service by Mumbai Airport Cab provides professional driver services combined with premium Innova vehicles for business travel, airport transfers, family trips, city tours, and long-distance journeys. Our experienced chauffeurs are trained in safe driving, route planning, and customer service, ensuring every passenger enjoys a secure, comfortable, and pleasant travel experience."
},
{
name: "Innova Long Distance Cab Mumbai",
description: "Innova Long Distance Cab Mumbai offers reliable transportation for extended road trips, intercity travel, pilgrimage tours, corporate journeys, and holiday vacations. Mumbai Airport Cab provides comfortable Innova vehicles with spacious seating, luggage capacity, experienced highway drivers, and flexible travel schedules. Our service ensures safety, convenience, and comfort throughout every long-distance journey."
},
{
name: "Innova Full Day Hire Mumbai",
description: "Mumbai Airport Cab provides Innova Full Day Hire Mumbai service for customers requiring dedicated transportation throughout the day. Ideal for business meetings, sightseeing tours, shopping trips, family events, and personal travel, our chauffeur-driven Innova vehicles offer flexibility, comfort, and convenience. We provide transparent pricing, professional service, and reliable travel solutions tailored to individual requirements."
},
{
name: "Innova Tour Package Mumbai",
description: "Book Innova Tour Package Mumbai with Mumbai Airport Cab for customized sightseeing tours, holiday vacations, pilgrimage journeys, weekend getaways, and family travel experiences. Our spacious Innova vehicles, experienced chauffeurs, flexible itineraries, and customer-focused service ensure comfortable and memorable journeys. We provide reliable transportation to popular destinations while delivering excellent comfort, safety, and convenience throughout the tour."
}
],

tableData: [
["Innova Car Rental Mumbai","Mumbai Innova Rental"],
["Innova Cab Mumbai","Mumbai Innova Cab Service"],
["Hire Innova in Mumbai","Innova on Rent Mumbai"],
["Mumbai Innova Car Hire","Innova Outstation Cab Mumbai"],
["Mumbai Innova Taxi Service","Mumbai Innova Booking Service"],
["Innova Crysta Rental Mumbai","Mumbai Luxury Innova Cab"],
["Innova Airport Pickup Mumbai","Innova Airport Drop Mumbai"],
["Mumbai Family Innova Cab","Innova Wedding Car Mumbai"],
["Mumbai Innova Chauffeur Service","Innova Long Distance Cab Mumbai"],
["Innova Full Day Hire Mumbai","Innova Tour Package Mumbai"]
],


whychoose: [
    {
        WhyChooseheading: "Premium Innova Car Rental in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides reliable Innova Car Rental services in Mumbai for airport transfers, family trips, corporate travel, weddings, sightseeing tours, and outstation journeys."
    },
    {
        WhyChooseheading: "Spacious and Comfortable Travel Experience",
        WhyChoosedescription: "Toyota Innova is known for its superior comfort, spacious seating, smooth ride quality, and ample luggage capacity, making it ideal for long-distance travel."
    },
    {
        WhyChooseheading: "Perfect for Family and Group Travel",
        WhyChoosedescription: "Whether you are planning a family vacation, pilgrimage tour, corporate trip, or weekend getaway, Innova offers comfortable travel for multiple passengers."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Customers can hire Innova for Mumbai city travel as well as destinations like Pune, Nashik, Shirdi, Mahabaleshwar, Lonavala, Goa, Ahmedabad, and other locations."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide seamless airport transfers with Innova vehicles for domestic and international travelers arriving at Mumbai Airport."
    },
    {
        WhyChooseheading: "Professional Chauffeur-Driven Service",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, route expertise, and a comfortable journey throughout your travel."
    },
    {
        WhyChooseheading: "Ideal for Corporate and Executive Travel",
        WhyChoosedescription: "Many business travelers and corporate clients prefer Innova for meetings, conferences, airport transfers, and official transportation requirements."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose one-way travel, round trips, multi-day tours, and customized travel packages according to their requirements."
    }
]
};

const faqData = [
    {
        question: "Why choose Innova Car Rental in Mumbai?",
        answer: "Innova offers spacious seating, premium comfort, excellent ride quality, and sufficient luggage space, making it one of the most preferred rental vehicles."
    },
    {
        question: "Can I book an Innova for Mumbai Airport transfers?",
        answer: "Yes, Innova vehicles are available for airport pickup and drop services from Mumbai Airport."
    },
    {
        question: "Is Innova available for outstation travel?",
        answer: "Yes, customers can hire Innova for destinations such as Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Ahmedabad, Jaipur, and many more."
    },
    {
        question: "How many passengers can travel in an Innova?",
        answer: "Innova comfortably accommodates up to 6 to 7 passengers along with luggage depending on the seating configuration."
    },
    {
        question: "Can corporate clients book Innova rentals?",
        answer: "Yes, many executives, business travelers, and corporate organizations prefer Innova for professional transportation."
    },
    {
        question: "Do you provide chauffeur-driven Innova rentals?",
        answer: "Yes, all Innova rentals from Mumbai Airport Cabs include professional and experienced drivers."
    },
    {
        question: "Can I book an Innova for wedding and event transportation?",
        answer: "Yes, Innova vehicles are frequently booked for weddings, family functions, corporate events, and special occasions."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, round trips, and customized travel packages."
    },
    {
        question: "Can I schedule an Innova rental in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability during weekends, holidays, and peak travel seasons."
    },
    {
        question: "How can I book an Innova Car Rental in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sanket Kulkarni",
        feedback:
            "We hired an Innova for our family trip and the experience was outstanding. The vehicle was spacious, comfortable, and perfect for long-distance travel.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priti Shah",
        feedback:
            "Mumbai Airport Cabs provided a well-maintained Innova for our airport transfer. The driver was professional, the vehicle was clean, and the journey was extremely comfortable.",
        rating: 5
    }
];









































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Innova Car Rental Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/innova-car-rental-mumbai.jpg",
"description": "Book Innova car rental in Mumbai for comfortable family travel, airport transfers, weddings, and outstation trips. Mumbai Airport Cabs offers Innova and Innova Crysta vehicles with professional drivers, spacious seating, and reliable 24x7 service.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/innova-car-rental-mumbai"
}
};







    return (
        <div>



<Helmet>
  <title>Innova Car Rental Mumbai | Innova Cab Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Innova car rental in Mumbai for family trips, airport transfers, weddings, and outstation travel. Comfortable Innova and Innova Crysta cabs with professional drivers and 24x7 service."
/>

<meta
 name="keywords"
 content="innova car rental mumbai, mumbai innova rental, innova cab mumbai, mumbai innova cab service, hire innova in mumbai, innova on rent mumbai, mumbai innova car hire, innova outstation cab mumbai, mumbai innova taxi service, innova crysta rental mumbai, mumbai luxury innova cab, innova airport pickup mumbai, innova airport drop mumbai, mumbai family innova cab, innova wedding car mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacarrentalmumbai;